import { useMutation, useQueryClient } from "react-query";
import { useUser } from "@/providers/context";
import { AxiosError } from "axios";
import { deleteFavourite, UpdateDefaultPlaylist } from "@/api";

export const useDeleteFavourite = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    Omit<UpdateDefaultPlaylist, "UserId">
  >(
    async (favourite) => {
      if (uid) {
        return await deleteFavourite({ ...favourite, UserId: uid });
      }
    },
    {
      onSuccess: (data) => {
        // Update the local favourites immediately with the response
        if (data) {
          queryClient.setQueryData(["favourites", uid], data);
        }
      },
    },
  );
};
